import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import css from './content.css';

const Content = ({ children, className, ...otherProps }) => (
  <div
    className={classnames([css['ds-card-content'], className])}
    {...otherProps}
  >
    {children}
  </div>
);

Content.defaultProps = {
  children: null,
  className: '',
};

Content.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Content;
